import queryString from 'query-string';
import React, { useEffect } from 'react';
import { ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import { parseJSON } from '@/utils/common';
import { Extension, ExtensionQuery } from './types';

export const ExtensionManager = {
    extension: null as Extension | null | undefined,
    extensionParams: null as object | null,
    extensions: [] as Extension[],

    launch() {
        const { extension_params, extension: extensionName } = queryString.parse(
            window.location.search,
        ) as ExtensionQuery;

        if (extensionName) {
            const extensionParams = parseJSON<object>(decodeURIComponent(extension_params || ''));

            ExtensionManager.extension = ExtensionManager.extensions.find(
                (extension) => extension.name === extensionName,
            );
            ExtensionManager.extensionParams = extensionParams;
        }
    },

    async launchExtension<T extends Extension = Extension>(
        extensionName: string,
        extensionParams: object | null = null,
    ) {
        const extension = ExtensionManager.extensions.find((extension) => extension.name === extensionName);
        if (!extension) return;
        extension.extensionParams = extensionParams;
        await extension.initExtension?.(ExtensionManager);
        return extension as T;
    },

    initSdkContainer() {},

    getExtension<T extends Extension = Extension>(extensionName: string) {
        return ExtensionManager.extensions.find((extension) => extension.name === extensionName) as T;
    },

    beforeInitLayers(layers: ILayerProps[]) {
        return ExtensionManager.extension?.beforeInitLayers?.(ExtensionManager, layers);
    },

    afterInitLayers(layers: ILayerProps[]) {
        return ExtensionManager.extension?.afterInitLayers?.(ExtensionManager, layers);
    },
};

export const ExtensionComponent = React.memo(() => {
    ExtensionManager.extensions = [];

    useEffect(() => {
        ExtensionManager.launch();
    }, []);

    return null;
});
